<template>
  <button
    class="btn btn-round pull-right btn-book"
    :class="[{'btn-rose': !status.disabled}]"
    :disabled="!!status.disabled"
  >{{ status.text }}</button>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
    },
  },
};
</script>
